import React from 'react'
import styled, { keyframes, css } from 'styled-components'

export default function NotificationIcon({ count = 0 }) {
	const [shake, setShake] = React.useState(false)

	React.useEffect(() => {
		if (count > 0) {
			setShake(true)
			const timer = setTimeout(() => setShake(false), 600)
			return () => clearTimeout(timer)
		}
	}, [count])

	return (
		<StyledWrapper hasNotifications={count > 0} isShaking={shake}>
			<div className="icon-container">
				{count > 0 && (
					<span className="badge-count">{count > 99 ? '99+' : count}</span>
				)}
				<label className="bell-wrapper">
					<input type="checkbox" readOnly checked={count > 0} />
					<svg
						className="bell-regular"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 448 512">
						<path d="M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
					</svg>
					<svg
						className="bell-solid"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 448 512">
						<path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
					</svg>
				</label>
			</div>
		</StyledWrapper>
	)
}

const shakeAnimation = keyframes`
  0% { transform: rotate(0); }
  15% { transform: rotate(10deg); }
  30% { transform: rotate(-10deg); }
  45% { transform: rotate(7deg); }
  60% { transform: rotate(-7deg); }
  75% { transform: rotate(4deg); }
  100% { transform: rotate(0); }
`

const StyledWrapper = styled.div`
	position: relative;
	display: inline-block;
	padding: 8px; /* Espaço para o badge não ser cortado pelo container pai */

	.icon-container {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.badge-count {
		position: absolute;
		top: -4px;
		right: -6px; /* Deslocado mais para a direita como solicitado */
		background-color: #ff4d4f;
		color: white;
		font-size: 9px; /* Reduzido em ~20% */
		min-width: 14px; /* Reduzido em ~20% */
		height: 14px; /* Reduzido em ~20% */
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 4px;
		border: 1.5px solid #fff;
		font-weight: 700;
		z-index: 10;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
		pointer-events: none;
	}

	.bell-wrapper {
		--color: #a5a5b0;
		font-size: 26px; /* Reduzido em ~20% (de 32px para 26px) */
		width: 1em;
		height: 1.14em;
		cursor: pointer;
		display: flex;
		fill: var(--color);
		transition: fill 0.3s ease;

		animation: ${(props) =>
			props.isShaking
				? css`
						${shakeAnimation} 0.6s ease-in-out
					`
				: 'none'};

		svg {
			width: 100%;
			height: 100%;
		}
	}

	.bell-solid {
		display: none;
	}

	${(props) =>
		props.hasNotifications &&
		css`
			.bell-wrapper {
				.bell-regular {
					display: none;
				}
				.bell-solid {
					display: block;
				}
			}
		`}

	.bell-wrapper input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}
`
